import { useAuth0 } from '@auth0/auth0-react';
import { LayoutBackofficeWrapper } from '@playsistemico/modo-ui-portal-lib';
import IconModo from 'src/global/assets/images/modo-icon.svg';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { changeTabEvent } from 'src/analitycs/pagesEvents/transactions';
import AvatarIcon from 'src/components/AvatarIcon';
import { checkForPermission, hasAnyPermission } from 'src/auth/permissions/utils';
import { useSelector } from 'react-redux';
import { getUserPermissions } from 'src/redux/reducers/user';
import { useState } from 'react';
import { GRAY_FOURTH } from 'src/global/theme/colors';

import { HIDE_SIDEBAR_ROUTES, sidebarOptions } from './utils';
import { styles } from './styles';

const LayoutDefault = () => {
  const { isAuthenticated } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useSelector(getUserPermissions);
  const { classes } = styles();

  const getInitialActiveTab = () => {
    const selectedOption = sidebarOptions.find((option) => location.pathname.includes(option.key));
    return selectedOption ? selectedOption.key : sidebarOptions[0].key;
  };

  const [activeTab, setActiveTab] = useState(getInitialActiveTab());

  const onClickMenuItem = (option: any) => {
    const oldSection = location.pathname.split('/')[1];
    if (oldSection !== option.key) {
      changeTabEvent(option.key, oldSection);
    }
    setActiveTab(option.key);
    navigate(option.to);
  };

  const shouldHideSidebar = HIDE_SIDEBAR_ROUTES.some((item) => location.pathname.includes(item));

  const filteredOptions = sidebarOptions.filter((option) =>
    option.anyOf
      ? hasAnyPermission(permissions, option.anyOf)
      : checkForPermission(permissions, option.permission)
  );

  return (
    <LayoutBackofficeWrapper
      avatar={isAuthenticated && <AvatarIcon />}
      logo={<img src={IconModo} alt="modo-logo" width="128" className={classes.modoIcon} />}
      onCLickLogo={() => {}}
      onClickMenuItem={onClickMenuItem}
      sideBarOptions={shouldHideSidebar ? [] : filteredOptions}
      activeTab={activeTab}
      backgroundColor={GRAY_FOURTH}>
      <div className={classes.outlet}>
        <Outlet />
      </div>
    </LayoutBackofficeWrapper>
  );
};

export default LayoutDefault;
